import { DatePipe } from '@angular/common';
import { Pipe, PipeTransform } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { LangService } from '../service/lang.service';

/** Use the angular date pipe but with the current app locale from LangService */
@Pipe({
  name: 'dateLocale$',
  standalone: false,
})
export class DateLocalePipe implements PipeTransform {
  constructor(
    private datePipe: DatePipe,
    private langService: LangService,
  ) {}

  /** See date formats https://angular.io/api/common/DatePipe#pre-defined-format-options */
  transform(
    value: string | number | Date | null | undefined,
    format = 'short',
    timezone?: string,
    locale?: string,
  ): Observable<string | null> {
    return this.langService.currentLang$.pipe(
      map((lang) => this.datePipe.transform(value, format, timezone, locale || lang)),
    );
  }
}
